Ext.define('SA.VectorMapExportThematicMapOverlay', {
    alias: 'widget.vector-map-export-thematic-map-overlay',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-vector-map-export-overlay sa-vector-map-export-overlay-loading',
    constrain: true,
    draggable: true,
    floating: true,
    height: 100,
    overCls: 'sa-vector-map-export-overlay-over',
    toFrontOnShow: false,
    width: 100,

    resizable: {
        preserveRatio: true,
        transparent: true
    },

    initComponent() {
        var modelState = this.model.getState();

        this.items = [{
            xtype: 'vector-map-export-thematic-map',
            attributionText: SA.VectorMapConstants.getAttributionText(),
            geoJsonSourcesData: SA.VectorMapThematicMapGeoJsonSourcesData.get(modelState, {enableServerSideClustering: false}),
            layersProperties: SA.VectorMapThematicMapLayersProperties.get(modelState),
            maxExtent: modelState.maxExtent,
            style: SA.VectorMapConstants.getThematicMapStyle(),
            styleBaseUrls: SA.VectorMapConstants.getThematicMapStyleBaseUrls(),
            tileSourcesUrls: SA.VectorMapThematicMapTileSourcesUrls.get(modelState)
        }];

        this.callParent();

        this.map = this.down('vector-map-export-thematic-map');
    },

    initEvents() {
        this.callParent();

        this.map.onHttpError(this.onMapHttpError, this);
        this.map.onLoadingChange(() => this.setLoading(this.map.isLoading() ? 'Loading preview…' : false));
    },

    afterRender() {
        this.callParent();

        this.getEl().addClsOnClick('sa-vector-map-export-overlay-drag');
    },

    getRecord() {
        return this.details.getMap();
    },

    onMapHttpError({exceptionClass}) {
        if (exceptionClass.endsWith('TooManyPointsException')) {
            this.map.setGeoJsonSourcesData(SA.VectorMapThematicMapGeoJsonSourcesData.get(this.model.getState(), {enableServerSideClustering: true}));
        }
    },

    onMouseDown: Ext.emptyFn,

    refresh() {
        var {details} = this,
            extent = SA.VectorMapExtent.fromXYBounds(this.extent.getBounds()),
            modelState = this.model.getState(),
            pageWidth = this.page.getWidth();

        this.map.setParams(SA.VectorMapExportParams.forThematicMap({details, extent, modelState, pageWidth}));
    },

    setLoading(loading) {
        this.callParent(arguments);

        this.ifCls(loading !== false, 'sa-vector-map-export-overlay-loading');
    }
});